import { render, staticRenderFns } from "./EmptySmall.vue?vue&type=template&id=76bf89e7&scoped=true&"
import script from "./EmptySmall.vue?vue&type=script&lang=js&"
export * from "./EmptySmall.vue?vue&type=script&lang=js&"
import style0 from "./EmptySmall.vue?vue&type=style&index=0&id=76bf89e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bf89e7",
  null
  
)

export default component.exports